import {toast} from "../hooks/use-toast";
import {meService} from "../services/me";

const DISPATCH_CENTER_SECTION_DISABLED =
  "This feature is not enabled for your dispatch center.";

export async function handleDispatchCenterSectionDisabled(message?: string): Promise<void> {
  toast.error(message?.trim() || DISPATCH_CENTER_SECTION_DISABLED);

  try {
    await meService.getMe();
  } catch {
    // Keep toast; /me refresh is best-effort.
  }
}
